(async () => {
  const q = s => document.querySelector(s);
  const qa = s => [...document.querySelectorAll(s)];
  const norm = s => (s||'').toString().trim().toUpperCase();
  const stripProto = s => (s||'').replace(/^https?:/,'').replace(/^\/\//,'');
  const log = (...a)=>console.log('[VariantDebug]', ...a);
  const warn = (...a)=>console.warn('[VariantDebug]', ...a);

  function dumpSliders() {
    const thumbs = qa('.c-prod-secondary-slider-item img, .product__thumb img, .thumbnails img');
    const primImgs = qa('.c-prod-primary-slider-item__image, .c-prod-primary-slider-item img, .product__main img, .product-media img, .c-product-media img');
    log('Thumbs:', thumbs.length);
    log('Primary imgs:', primImgs.length, primImgs.map((img,i)=>({i,src:img?.src})));
  }

  const handle =
    (location.pathname.match(/\/products\/([^\/?#]+)/i)||[])[1] ||
    (q('link[rel="canonical"]')?.href.match(/\/products\/([^\/?#]+)/i)||[])[1] ||
    (() => {
      for (const s of qa('script[type="application/ld+json"]')) {
        try {
          const j = JSON.parse(s.textContent);
          const arr = Array.isArray(j) ? j : [j];
          for (const it of arr) {
            if (it && it['@type']==='Product' && it.url) {
              const m = it.url.match(/\/products\/([^\/?#]+)/i);
              if (m) return m[1];
            }
          }
        } catch {}
      }
      return null;
    })();

  if (!handle) { warn('No product handle'); dumpSliders(); return; }

  const product = await fetch(`/products/${handle}.js`, { credentials:'same-origin' }).then(r=>r.json()).catch(e=>({error:e}));
  if (!product || product.error) { warn('Product JSON fetch failed', product?.error); return; }
  log('Product:', {id:product.id, title:product.title, variants:product.variants.length});

  const vByKey = new Map();
  const v2media = new Map();
  for (const v of product.variants) {
    const key = [v.option1, v.option2, v.option3].map(norm).join('|');
    vByKey.set(key, v);
    const mediaId = v.featured_media?.id || v.featured_image?.id || null;
    const src = v.featured_media?.preview_image?.src || v.featured_image?.src || null;
    v2media.set(v.id, { mediaId, src });
  }
  log('Maps built:', { keys: vByKey.size, mediaMap: v2media.size });

  const readUI = () => {
    const color =
      q('.c-colour-swatch-input-sim__input:checked')?.value ||
      q('[name="options[Colour]"]:checked')?.value ||
      q('[data-option-index="0"] [type=radio]:checked')?.value ||
      q('[data-option-position="1"] [type=radio]:checked')?.value ||
      q('.c-colour-swatch-input-sim__input')?.value ||
      q('[name="options[Colour]"]')?.value;
    const size =
      q('.c-size-input-sim__input:checked')?.value ||
      q('[name="options[Size]"]:checked')?.value ||
      q('[data-option-index="1"] [type=radio]:checked')?.value ||
      q('[data-option-position="2"] [type=radio]:checked')?.value ||
      q('.c-size-input-sim__input')?.value ||
      q('[name="options[Size]"]')?.value;
    return { color, size };
  };

  const matchVariant = ({color,size}) => {
    const K = [norm(color), norm(size), ''].join('|');
    let v = vByKey.get(K);
    if (!v) v = product.variants.find(x => norm(x.option1)===norm(color) && (!size || norm(x.option2)===norm(size)));
    return v || null;
  };

  const findSlideIndex = ({mediaId, src}) => {
    const thumbs = qa('.c-prod-secondary-slider-item img, .product__thumb img, .thumbnails img');
    if (mediaId) {
      const i1 = thumbs.findIndex(img => img.closest('[data-media-id]')?.getAttribute('data-media-id') == String(mediaId));
      if (i1 >= 0) return i1;
    }
    if (src) {
      const clean = stripProto(src);
      const i2 = thumbs.findIndex(img => stripProto(img.src) === clean);
      if (i2 >= 0) return i2;
    }
    return -1;
  };

  const goToIndex = (idx) => {
    if (idx < 0) return false;
    const thumbSlides = qa('.c-prod-secondary-slider-item, .product__thumb, .thumbnails .thumbnail')
      .map(el => el.closest('.slick-slide') || el);
    if (thumbSlides.length) {
      const s = thumbSlides[idx] || thumbSlides.find(x => x?.dataset?.slickIndex == idx);
      if (s) { log('Clicking thumbnail @', idx); s.click(); return true; }
    }
    const dots = qa('.slick-dots li button');
    if (dots.length && dots[idx]) { log('Clicking dot @', idx); dots[idx].click(); return true; }
    const primSlides = qa('.c-prod-primary-slider-item').map(el => el.closest('.slick-slide') || el);
    if (primSlides.length) {
      const s = primSlides[idx] || primSlides.find(x => x?.dataset?.slickIndex == idx);
      if (s) { log('Clicking primary @', idx); s.click(); return true; }
    }
    return false;
  };

  const setFormVariant = (variantId) => {
    let ok = false;
    const form = q('form[action="/cart/add"]') || q('form');
    const sel = form?.querySelector('select[name="id"]');
    const inp = form?.querySelector('input[name="id"]');
    if (sel) { sel.value = String(variantId); sel.dispatchEvent(new Event('change', {bubbles:true})); ok = true; }
    if (inp) { inp.value = String(variantId); inp.dispatchEvent(new Event('change', {bubbles:true})); ok = true; }
    form?.dispatchEvent(new CustomEvent('variant:change', {bubbles:true, detail:{ id: variantId }}));
    form?.dispatchEvent(new CustomEvent('variant:changed', {bubbles:true, detail:{ id: variantId }}));
    form?.dispatchEvent(new CustomEvent('product:variant:change', {bubbles:true, detail:{ id: variantId }}));
    return ok;
  };

  const hardSwapAllMainImages = (src) => {
    if (!src) return 0;
    const candidates = qa(`
      .c-prod-primary-slider-item__image,
      .c-prod-primary-slider-item img,
      .product__main img,
      .product-media img,
      .c-product-media img,
      .product__media img,
      .c-prod-primary-slider-item picture source
    `);
    let changed = 0;
    for (const el of candidates) {
      if (el.tagName === 'SOURCE') {
        el.srcset = src;
        changed++;
      } else if (el.tagName === 'IMG') {
        el.src = src;
        el.srcset = '';
        el.removeAttribute('srcset');
        changed++;
      }
    }
    return changed;
  };

  const applyFromUI = (why='user-change') => {
    const sel = readUI();
    log(`Apply(${why})`, sel);

    const variant = matchVariant(sel);
    if (!variant) { warn('No matching variant for', sel); return; }
    log('Variant found:', { id: variant.id, title: variant.title });

    const media = v2media.get(variant.id) || {};
    log('Variant media:', media);

    const formOk = setFormVariant(variant.id);
    log('Form set ok?', formOk);

    const idx = findSlideIndex(media);
    log('Calculated slide index:', idx);

    let jumped = goToIndex(idx);
    log('Slider jump success?', jumped);

    if (!jumped) {
      const src = media.src || variant.featured_media?.preview_image?.src || variant.featured_image?.src;
      const changed = hardSwapAllMainImages(src);
      if (changed) {
        log('HARD fallback: swapped', changed, 'img(s) to', src);
        jumped = true;
      } else {
        warn('HARD fallback failed: no target images found');
      }
    }

    dumpSliders();
    window.__lastVariantDebug = { sel, variant, media, idx, jumped };
  };

  qa('.c-colour-swatch-input-sim__input, .c-size-input-sim__input, [name="options[Colour]"], [name="options[Size]"]')
    .forEach(i => i.addEventListener('change', () => applyFromUI('change')));

  qa('.c-colour-swatch-input-sim__label, .c-size-input-sim__label, label[for^="colour-"], label[for^="size-"]')
    .forEach(l => l.addEventListener('click', () => setTimeout(()=>applyFromUI('label-click'),0)));

  window.pickVariant = (color, size) => {
    log('pickVariant()', color, size);
    const c = qa('.c-colour-swatch-input-sim__input, [name="options[Colour]"]').find(x => norm(x.value)===norm(color));
    const s = qa('.c-size-input-sim__input, [name="options[Size]"]').find(x => norm(x.value)===norm(size));
    if (c) { c.checked = true; c.dispatchEvent(new Event('change', {bubbles:true})); }
    if (s) { s.checked = true; s.dispatchEvent(new Event('change', {bubbles:true})); }
    applyFromUI('manual-pick');
  };

  applyFromUI('init');
  log('Ready (no groups). Helpers: pickVariant(color,size), __lastVariantDebug');
})();
